import { prefixCls } from '@/constants';

export default function IconWrapper({ normalIcon, activedIcon }) {
  return (
    <>
      <span
        className={`dripicon dripicon-menu-unfold anticon anticon-menu-unfold ${prefixCls}-menu-item-icon side-menu-icon-normal`}
      >
        {normalIcon}
      </span>
      <span
        className={`dripicon dripicon-menu-unfold anticon anticon-menu-unfold ${prefixCls}-menu-item-icon side-menu-icon-actived`}
      >
        {activedIcon}
      </span>
    </>
  );
}
